var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpenQuote = function SvgOpenQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.157 8.16c-2.8 1.027-4.947 2.613-6.44 4.76-1.4 2.147-2.1 4.713-2.1 7.7h8.54v18.9h-17.5v-18.9c0-2.613.466-5.04 1.4-7.28.933-2.24 2.193-4.2 3.78-5.88a22.948 22.948 0 0 1 5.46-4.48 34.533 34.533 0 0 1 6.86-2.94v8.12Zm-27.86 0c-2.8 1.027-4.947 2.613-6.44 4.76-1.4 2.147-2.1 4.713-2.1 7.7h8.54v18.9H.797v-18.9c0-2.613.466-5.04 1.4-7.28.933-2.24 2.193-4.2 3.78-5.88a22.947 22.947 0 0 1 5.46-4.48 34.533 34.533 0 0 1 6.86-2.94v8.12Z",
    fill: "#007B82"
  })));
};

export default SvgOpenQuote;